import type { FunctionComponent } from 'react';

export const VisibilityPublicIcon: FunctionComponent = () => {
    return (
        <svg fill="none" height="32" width="32" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="15" fill="#374151" r="3" />
            <path
                d="M17.192 22.922A9.1 9.1 0 0 1 16 23c-7 0-11-8-11-8s4-8 11-8c6.326 0 10.202 6.534 10.89 7.792A6.472 6.472 0 0 0 23 13.5a6.49 6.49 0 0 0-2.131.357A5.002 5.002 0 0 0 11 15a5 5 0 0 0 5.5 4.975V20c0 1.05.25 2.043.692 2.922Z"
                fill="#374151"
            />
            <circle cx="23" cy="20" fill="#374151" r="5" />
            <path
                d="M23 16.25c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75 2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75ZM20 20a3 3 0 0 1 .079-.668l1.792 1.793v.375c0 .413.338.75.75.75v.724A3.004 3.004 0 0 1 20 20Zm5.209 2.025a.747.747 0 0 0-.713-.525h-.375v-1.125a.376.376 0 0 0-.375-.375h-2.25v-.75h.75a.376.376 0 0 0 .375-.375v-.75h.75c.413 0 .75-.337.75-.75v-.154A3.001 3.001 0 0 1 26 20a3 3 0 0 1-.791 2.025Z"
                fill="#fff"
            />
        </svg>
    );
};
